import { checkPassengerDetailsCompletionAction } from "../../../../Actions/LogicActions/Checkout/PassengerDetails/CheckPassengerDetailsCompletionAction";
import { getPassengerDetailsAction } from "../../../../Actions/LogicActions/Checkout/PassengerDetails/GetPassengerDetailsAction";
import { getCountryCodesAction } from "../../../../Actions/LogicActions/MyAccount/PersonalInformation/GetCountryCodesAction";
import { rememberMeChangeAction } from "../../../../Actions/UIActions/Checkout/PassengerDetails/RememberMeChangeAction";
import { selectPassengerAction } from "../../../../Actions/UIActions/Checkout/PassengerDetails/SelectPassengerAction";
import { syncContactPassengerDataAction } from "../../../../Actions/UIActions/Checkout/PassengerDetails/SyncContactPassengerDataAction";
import { unmountPassengerDetailAction } from "../../../../Actions/UIActions/Checkout/PassengerDetails/UnmountPassengerDetailAction";
import { updateContactFormDataAction } from "../../../../Actions/UIActions/Checkout/PassengerDetails/UpdateContactFormDataAction";
import { updatePassengerDataAction } from "../../../../Actions/UIActions/Checkout/PassengerDetails/UpdatePassengerDataAction";
import { signInAction } from "../../../../Actions/UIActions/MyAccount/SignInAction";
import { ExecutionStatus } from "../../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../../core/events/EventBus";
import { StepDefinition } from "../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../core/flows/StepFlow";
import { evtTree } from "../../../../Orchestrator/ConstantTree";
import { checkoutTree } from "../../../../Orchestrator/ConstantTree/CheckoutPage/CheckoutTree";
import { IPassenger, PassengerSelectReqType, RememberMeReqType, SyncCustomerPassenger, UpdateCustomerContactForm, UpdatePassengerReqType } from "../../../../Orchestrator/Types/Index";
import { ISignInActionParams } from "../../../../Orchestrator/Types/Interface/ActionParams/BookingDetailActionParams";
import { IPassengerChange } from "../../../../Orchestrator/Types/Interface/EventParams/PassengerAction";
import { TicketOptionContext } from "../../../TrainOfferPage/TicketOptionFlow/Context/TicketOptionContext";
import { CheckoutContext } from "../../Context/CheckoutContext";
import { PassengerDetailsContext } from "../Context/PassengerDetailsContext";

class PassengerDetailsInitStep extends StepFlow {
    get stepName() { return "PassengerDetailsInit_Step"; }
    private isBrowserUnloadInProgress = false;
    private readonly handleBeforeUnload = () => {
        this.isBrowserUnloadInProgress = true;
    };

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on({
                eventName: checkoutTree.PassengerDetails.Init,
                handler: async () => {
                    let context = this.getCtx<PassengerDetailsContext>("passengerDetailsContext")!;
                    let checkoutContext = this.getCtx<CheckoutContext>("checkoutContext")!;
                    let ticketOptionContext = this.getCtx<TicketOptionContext>("ticketOptionContext")!;
                    if (context) {
                        /**
                         * This  condition is required because,
                         * When we have isAnonymous is true means guest user.
                         * So for guest user no need to call /me API and no need to
                         * set custom contact and saved passenger
                        */                        
                        if (!checkoutContext?.isAnonymous && !ticketOptionContext?.isAnonymous) {
                            await getPassengerDetailsAction.execute();
                            if (getPassengerDetailsAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                                context.customerContactData = getPassengerDetailsAction?.result?.customerData;
                                context.savedPassengers = getPassengerDetailsAction?.result?.savedPassenger;
                            }
                        }
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<UpdatePassengerReqType, void>({
                eventName: checkoutTree.PassengerDetails.UpdatePassengerData,
                handler: async (payload) => {
                    let context = this.getCtx<PassengerDetailsContext>("passengerDetailsContext")!;
                    context.updatePassengerReqType = payload.data!
                    updatePassengerDataAction.setParams({ ...context.updatePassengerReqType })
                    await updatePassengerDataAction.execute();
                    if (updatePassengerDataAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                        context.updatedCustomerContact = updatePassengerDataAction?.result?.updatedCustomer;
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<UpdateCustomerContactForm, void>({
                eventName: checkoutTree.CustomerContact.Change,
                handler: async (payload) => {
                    let context = this.getCtx<PassengerDetailsContext>("passengerDetailsContext")!;
                    context.updateCustomerContactForm = payload.data!
                    updateContactFormDataAction.setParams({ ...context.updateCustomerContactForm })
                    await updateContactFormDataAction.execute();
                    if (updateContactFormDataAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                        context.updatedCustomerContact = updateContactFormDataAction?.result?.updatedCustomer;
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<SyncCustomerPassenger, void>({
                eventName: checkoutTree.PassengerDetails.SyncCustomerPassenger,
                handler: async (payload) => {
                    let context = this.getCtx<PassengerDetailsContext>("passengerDetailsContext")!;
                    context.syncCustomerPassenger = payload.data!
                    syncContactPassengerDataAction.setParams({ ...context.syncCustomerPassenger })
                    await syncContactPassengerDataAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<PassengerSelectReqType, void>({
                eventName: checkoutTree.PassengerDetails.Select,
                handler: async (payload) => {
                    let context = this.getCtx<PassengerDetailsContext>("passengerDetailsContext")!;
                    context.passengerSelectReqType = payload.data!
                    selectPassengerAction.setParams({ ...context.passengerSelectReqType })
                    await selectPassengerAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<RememberMeReqType, void>({
                eventName: checkoutTree.PassengerDetails.RememberMe.Change,
                handler: async (payload) => {
                    let context = this.getCtx<PassengerDetailsContext>("passengerDetailsContext")!;
                    context.rememberMeReqType = payload.data!
                    rememberMeChangeAction.setParams({ ...context.rememberMeReqType })
                    await rememberMeChangeAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IPassengerChange, void>({
                eventName: checkoutTree.PassengerDetails.Change,
                handler: async (payload) => {
                    checkPassengerDetailsCompletionAction.setParams(payload.data!);
                    checkPassengerDetailsCompletionAction.execute();
                }
            })
        );

        this.registerEventSubscription(
            _eventBus.on({
                eventName: checkoutTree.Invoice.Init,
                handler: async (data: any) => {
                    await getCountryCodesAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: checkoutTree.PassengerDetails.Unmount,
                handler: async (payload) => {
                    unmountPassengerDetailAction.execute()
                }
            })
        );

        /**
         * This event is manage guest checkout login.
         * We have a login option from checkout.
        */
        this.registerEventSubscription(
            _eventBus.on<ISignInActionParams, void>({
                eventName: evtTree.Checkout.Login.Click,
                handler: async ({ data }) => {
                    if (data) {
                        signInAction.setParams({ isAuthenticated: false, login: data.login, guestCheckoutBookingId: data.guestCheckoutBookingId })
                        await signInAction.execute();
                    }
                }
            })
        );
    }

    async onExecute(): Promise<void> {
        this.setCtx("passengerDetailsContext", PassengerDetailsContext)
        if (typeof window !== "undefined") {
            this.isBrowserUnloadInProgress = false;
            window.addEventListener("beforeunload", this.handleBeforeUnload);
        }
        console.log("Passenger Details Init step call............");
        _eventBus.emit({
            eventName: checkoutTree.PassengerDetails.Init
        });
    }

    /**
     * @method onEventTearDown
     * Added this event - when Event Tear Down - Need to update/Reset recoil state
    */
    async onEventTearDown(): Promise<void> {
        if (typeof window !== "undefined") {
            window.removeEventListener("beforeunload", this.handleBeforeUnload);
        }
        if (this.isBrowserUnloadInProgress) {
            return;
        }
        _eventBus.emit({
            eventName: checkoutTree.PassengerDetails.Unmount
        })
    }

}
export const passengerDetailsInitStepDefinition = new StepDefinition({
    stepName: "PassengerDetailsInit_Step",
    stepClass: PassengerDetailsInitStep
});